<template>
  <transition name="add_campaigns">
    <div class="modal_add_campaigns_wrap" v-if="dialog">
      <div class="modal_add_campaigns">
        <h1>Create campaign</h1>
        <div class="flex row jcsb">
          <span>Affiliate</span>
          <custom-select :options="campaignsSflAffiliates" v-model="createCampaignParams.affiliate" label="nameId" @search="updateCampaignAffiliates" :filterable="false" class="custom_select" :clearable="false"></custom-select>
          <v-progress-circular
              class="custom_select_circular"
              v-if="campaignsSflAffiliates.length == 0 ? true : false"
              indeterminate
              color="primary"
              size="20"
          ></v-progress-circular>
        </div>
        <div class="flex row jcsb">
          <span>Advertiser</span>
          <custom-select :options="getAdvertisers" label="advertiserNameId" :reduce="advertiser => advertiser.advertiser_id" v-model="createCampaignParams.advertiser" class="custom_select" :clearable="false"></custom-select>
          <v-progress-circular
              class="custom_select_circular"
              v-if="getAdvertisers.length == 0 ? true : false"
              indeterminate
              color="primary"
              size="20"
          ></v-progress-circular>
        </div>
        <div class="flex row jcsb">
          <span>Offer</span>
          <custom-select aria-placeholder="Select advertiser first" @input="onOfferSelect" :options="offers" label="offerNameId" @search="updateCampaignOffers" v-model="createCampaignParams.offer" class="custom_select" :clearable="false"></custom-select>
          <v-progress-circular
              class="custom_select_circular"
              v-if="isloadOffers"
              indeterminate
              color="primary"
              size="20"
          ></v-progress-circular>
        </div>
        <div class="flex row jcsb">
            <span>Variant</span>
            <custom-select aria-placeholder="Select advertiser first" v-model="createCampaignParams.variant" :options="getOfferVariants" label="name" class="custom_select" :clearable="false"></custom-select>
        </div>
        <div class="flex row jcsb align-center">
          <span>Campaign Name</span>
          <div style="display: flex; align-items: center;">
            <v-icon
                    small
                    class="mr-2"
                    @click="generateCampaignName"
                    title="Auto-generate campaign name"
            >
              mdi-auto-fix
            </v-icon>
            <input type="text" v-model="createCampaignParams.name" class="campaigns_name_input">
          </div>
        </div>
        <div class="flex row left-align">
            <span class="preview">Preview</span>
            <div class="flex row right-align img">
                <v-img
                        v-if="createCampaignParams.variant && createCampaignParams.variant.preSignedUrl"
                        :src="createCampaignParams.variant.preSignedUrl"
                        :alt="createCampaignParams.variant.imageName"
                        max-width="400"
                        class="mt-4"
                ></v-img>
            </div>
        </div>
        <div class="flex row right-align">
            <ExtraParamsComponent
                ref="extraParamsComponent"
                :extraParams="this.extraParams"
                :isInit="isExtraParamInit"
                :key="extraParams ? extraParams.length: 1"
                :currentVariant="currentVariant"
            />
        </div>
        <div class="flex row left">
        </div>
        <div class="flex row jcsb createCampaignBtnWrap">
          <button @click="dialog = !dialog" class="btn">Cancel</button>
          <button
              class="btn"
              @click="createCampaign"
              :disabled="createCampaignValidation"
              :class="{disabled_btn: createCampaignValidation}"
          >
            Create
          </button>
        </div>
      </div>
      <v-progress-circular
          class="progress-absolute"
          v-if="loading"
          indeterminate
          color="primary"
          size="50"
      ></v-progress-circular>
    </div>
  </transition>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import store from "@/store";
import {getCookie} from "@/helpers";
import {debounce} from "debounce";
import ExtraParamsComponent from "@/components/common/CampaignParams.vue";
import DisplayVariants from "@/components/common/DisplayVariants";
import ofersApi from "@/api/offers";

export default {
  name: "NewCampaign",
    components: {
        DisplayVariants,
        ExtraParamsComponent
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    offer: {
      type: Object,
      default: null
    }
  },
  model: {
    prop: 'open',
    event: 'toggle'
  },
  data() {
    return {
      loading: false,
      currentOffer: null,
      dialog: this.open,
      defaultOfferPayOut: '',
      useDates: false,
      offers: [],
      isloadOffers: false,
      saleAmountDay: 0,
      saleAmountWeek: 0,
      saleAmountMonth: 0,
      saleRedirectOfferId: null,
      clickAmountDay:0,
      clickAmountWeek:0,
      clickAmountMonth:0,
      clickRedirectOfferId: null,
      start: "",
      end: "",
      extraParams: [],
      isExtraParamInit: false,
      currentVariant:null,
      createCampaignParams: {
        name: '',
        affiliate: {},
        advertiser: {},
        offer: {},
        isCapsEnabled: 0,
        marginType: '%',
        variant: null,
      },
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('offers', ['getAdvertisers', 'getOffers']),
    ...mapState('affiliates', ['campaignsSflAffiliates']),
    ...mapGetters('offer', ['getOffersAggregated','getOfferVariants']),
    createCampaignValidation() {
      return !(!!this.createCampaignParams.name &&
          !!this.createCampaignParams.affiliate.name &&
          !!this.createCampaignParams.advertiser &&
          !!this.createCampaignParams.offer.id
          ) && this.createCampaignParams.offer.type !== 'aggregated';
    }
  },
  async mounted() {
    this.dialog = this.open
    store.dispatch('affiliates/getSflAffiliates', {token: getCookie('accessToken'), entity: 'campaigns'})
    store.dispatch('offers/saveAdvertisersStore', {token: getCookie('accessToken')})
    // await store.dispatch('offers/saveOffersStore', {
    //   filters: {},
    //   token: getCookie('accessToken')
    // })
    // this.offers = (this.getOffers.data && this.getOffers.data.length) ? this.getOffers.data.map(offer => {
    //   if (offer.status !== 'inactive') {
    //     return {value: offer.id, text: `(${offer.id}) ${offer.name}`}
    //   }
    // }).filter(offer => offer) : []

    const filters = {};
    this.offers = await this.getOffersWithoutStore(filters);
    this.offers = this.offers.filter(offer => offer.status !== 'inactive');

  },
  methods: {
    ...mapActions('alert', ['ALERT_SUCCESS', 'ALERT_ERROR', 'ALERT_INFO', 'ALERT_WARNING', 'ALERT']),
    updateCampaignAffiliates(search, loading) {
      loading(true)
      this.debounceUpdateCampaignAffiliates(search, loading)
    },
    updateCampaignOffers(search, loading) {
      loading(true)
      this.debounceUpdateCampaignOffers(search, loading, this.createCampaignParams.advertiser)
    },
    async onOfferSelect(ev) {
      await this.$store.dispatch('offer/saveOfferVariantsStore', this.createCampaignParams.offer.id);

      this.createCampaignParams.variant = this.getOfferVariants.find(variant => variant.isDefault === true);

      if (!this.createCampaignParams.offer.marginType) return;
      this.createCampaignParams.marginType = this.createCampaignParams.offer.marginType === 'fixed' ? 'Fixed amount' : '%';
      this.createCampaignParams.offer.payOut = this.createCampaignParams.offer.marginType === 'fixed'
         ? this.createCampaignParams.offer.payOut
         : this.createCampaignParams.offer.payoutPercent
    },
    getParams() {
      return this.$refs.extraParamsComponent.getLocalParams();
    },
    async createCampaign() {
      this.loading = true;
      const extraParams = this.getParams();

      const params = {
        name: this.createCampaignParams.name,
        offerId: this.createCampaignParams.offer.id,
        affiliateId: this.createCampaignParams.affiliate.id,
        user: this.$store.state.user.user[0].email,
        payOut: this.createCampaignParams.marginType === '%' ? 0: this.createCampaignParams.offer.payOut,
        payoutPercent: this.createCampaignParams.marginType === 'Fixed amount' ? 0 : this.createCampaignParams.offer.payOut,
        marginType: this.createCampaignParams.marginType === 'Fixed amount' ? 'fixed' : 'percent',
        variantId: this.createCampaignParams.variant ?   this.createCampaignParams.variant.id : 0
      };

      if (extraParams.length) {
          params.subIds = JSON.stringify(extraParams).replace(/"/g, "'");
      }

      if(this.createCampaignParams.offer.type === 'aggregated') {
        params.marginType = null;
      }

      params.clickAmountDay = parseFloat(this.clickAmountDay);
      params.clickAmountWeek = parseFloat(this.clickAmountWeek);
      params.clickAmountMonth = parseFloat(this.clickAmountMonth);

      params.saleAmountDay = parseFloat(this.saleAmountDay);
      params.saleAmountWeek = parseFloat(this.saleAmountWeek);
      params.saleAmountMonth = parseFloat(this.saleAmountMonth);

      params.saleRedirectOfferId = this.saleRedirectOfferId ? parseInt(this.saleRedirectOfferId) : 0;
      params.clickRedirectOfferId = this.clickRedirectOfferId ? parseInt(this.clickRedirectOfferId) : 0;
      params.start = this.start;
      params.end = this.end;
      params.useCaps = !!(this.createCampaignParams.isCapsEnabled);

      try {
        await store.dispatch('campaigns/createCampaign', {
          token: getCookie('accessToken'),
          params
        })
        this.dialog = !this.dialog
        this.createCampaignParams = {
          name: '',
          affiliate: {},
          advertiser: {},
          offer: {},
        };
        this.loading = false;
        this.clearData();
        this.ALERT_SUCCESS('Campaign was created 👍');
        setTimeout(() => {
          this.ALERT_SUCCESS('');
        }, 3500)
        // emit created event
        this.$emit('created');
      } catch (e) {
        this.loading = false;
      }

    },
    async updateOffersStore() {
      await store.dispatch('offers/saveOffersStore', {
        filters: {
          advertiserName: this.createCampaignParams.advertiser
        },
        token: getCookie('accessToken')
      })
    },
    async getOffersWithoutStore(filters) {
        const offers = await ofersApi.getSflOffers({payload: {filters}});
        return offers && offers.data ? offers.data: [];
    },
    debounceUpdateCampaignAffiliates: debounce(async (search, loading) => {
      await store.dispatch('affiliates/getSflAffiliates', { token: getCookie('accessToken'), entity: 'campaigns', searchFilter: search })
      loading(false)
    }, 700),
    debounceUpdateCampaignOffers: debounce(async (search, loading, advertiserId = null) => {
        const filters = {};
        if (search) {
            filters.searchOfferNames = search
        }
        if (advertiserId) {
            filters.advertiserName = advertiserId
        }

        // this.offers = await this.getOffersWithoutStore(filters);
        await store.dispatch('offers/saveOffersStore', {
          filters,
          token: getCookie('accessToken')
        })
        loading(false)
    }, 700),
    selectOffer(type, offer) {
      if (type === 'click') {
        this.clickRedirectOfferId = offer.value;
      } else if (type === 'sale') {
        this.saleRedirectOfferId = offer.value;
      }
    },
    updStart(date) {
      this.start = date;
    },
    updEnd(date) {
      this.end = date;
    },
    clearData() {
      this.start = "";
      this.end = "";
      this.clickAmountDay = 0;
      this.clickAmountWeek = 0;
      this.clickAmountMonth = 0;

      this.saleAmountDay = 0;
      this.saleAmountWeek = 0;
      this.saleAmountMonth = 0;
      this.createCampaignParams = {
        name: '',
        affiliate: {},
        advertiser: {},
        offer: {},
        variant: null,
      };
      this.currentVariant = null;
      this.isExtraParamInit = false;
      this.extraParams = [];
    },
    generateCampaignName() {
      const offer = this.createCampaignParams.offer;
      const variant = this.createCampaignParams.variant;

      if (offer && offer.name) {
        this.createCampaignParams.name = variant && variant.name
                ? `${offer.name} (${variant.name})`
                : `${offer.name}`;
      } else {
        this.ALERT_WARNING('Select an offer first to generate a campaign name');
      }
    }

  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    offer: {
      deep: true,
      async handler(newVal) {
          if (newVal) {
             this.isloadOffers = true;
             this.offers = await this.getOffersWithoutStore({});
             await this.$store.dispatch('offer/saveOfferVariantsStore', newVal.id);
             this.isloadOffers = false;
             if (this.offers) {
                 this.createCampaignParams.advertiser = this.getAdvertisers && this.getAdvertisers.length
                     ? this.getAdvertisers.find(advertiser => advertiser.advertiser_id === newVal.advertiserId): {};
                 if (this.createCampaignParams.advertiser) {
                     this.createCampaignParams.advertiser = this.createCampaignParams.advertiser.advertiser_id;
                 }
                 this.createCampaignParams.offer = this.offers.find(offer => offer.id === newVal.id);
             }
             this.createCampaignParams.variant = this.getOfferVariants.find(variant => variant.id === newVal.variantId);
         }
      }
    },
    open() {
      this.dialog = this.open
    },
    async 'createCampaignParams.advertiser'() {
      this.isloadOffers = true;
      const filters = {};
      filters.advertiserName = this.createCampaignParams.advertiser;
      this.offers = await this.getOffersWithoutStore(filters);
      this.offers = this.offers.filter(offer => offer.status !== 'inactive');
      this.isloadOffers = false;
      if (this.offer) {
          this.createCampaignParams.offer = this.offers.find(offer => offer.id === this.offer.id) || {};
      }
    },
    'createCampaignParams.offer'() {
      this.defaultOfferPayOut = this.createCampaignParams.offer.payOut
    },
    'createCampaignParams.variant'() {
      if (this.createCampaignParams.offer && this.createCampaignParams.variant) {
        this.extraParams = [];
        this.isExtraParamInit = true;
        this.currentVariant = this.createCampaignParams.variant;
        this.generateCampaignName();
      }
    },
  },
}
</script>

<style scoped lang="sass">
  span.payout_percent
    margin-left: auto
    margin-right: 5px
    margin-top: 5px
  .custom_select_margin
    width: 150px
  .divider
    border-width: 1px !important
    border-color: chocolate !important
  .progress-absolute
    position: absolute
    left: 0
    right: 0
    top: 0
    bottom: 0
    margin: auto
  .right-align
    display: flex
    justify-content: flex-end
  .left-align
    display: flex
    justify-content: flex-start
  .extra-params
    margin-top: 5% !important
  .preview
    padding-top: 10%
  .img
    padding-right: 2%
</style>
